<script lang="ts">
import TopBar from '@/components/layout/organisms/TopBar.vue';
import { authenticateUser } from '@/services/auth';
import { defineComponent, onBeforeMount, nextTick, computed } from 'vue';
import { useRoute } from 'vue-router';
import axe from 'axe-core';
import { $log } from './main';
import { version } from '../package.json';

export default defineComponent({
  components: {
    TopBar
  },
  setup() {
    const route = useRoute();
    const isLoginRoute = computed(() => route.name === 'login');

    onBeforeMount(async () => {
      try {
        await authenticateUser();
      } catch {
        // authenticateUser handles navigation to /login on failure
      }
    });

    const runAccessibilityTests = () => {
      nextTick(() => {
        axe.run()
          .then(results => {
            $log.info('AXE', results);
            if (results.violations.length) {
              throw new Error('Accessibility issues found');
            }
          })
          .catch(err => {
            $log.error('Something bad happened:', err.message);
          });
      });
    };

    return { runAccessibilityTests, version, isLoginRoute };
  }
});
</script>

<template>
  <q-layout
    view="hHh Lpr lff"
    container
    style="height: 100vh"
    class="rounded-borders"
  >
    <TopBar v-if="!isLoginRoute" />
    <q-page-container class="q-pa-sm">
      <router-view />
      <div
        v-if="!isLoginRoute"
        class="row justify-end q-pr-md"
      >
        <b class="q-mr-sm">CCP Version: </b><span> {{ version }}</span>
      </div>
    </q-page-container>
  </q-layout>
</template>

<style lang="sass">
/* change scrollbar style */
::-webkit-scrollbar
  height: 10px
  width: 10px
  background: #eeeeee

::-webkit-scrollbar-thumb
  background: #b0b0b0
</style>